exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#notifications-wrapper{overflow-x:hidden;overflow-y:scroll;-webkit-overflow-scrolling:touch;height:100vh}#notifications-wrapper .notifications-popup{box-shadow:none;width:100%;height:100%;margin-bottom:0;border-radius:0}#notifications-wrapper .notifications-popup .notifications-popup-inner{height:100%!important}#notifications-wrapper .notifications-popup .notifications-popup-inner--hidden{display:none}#notifications-wrapper .notifications-popup .notifications-popup-inner .notifications-popup-scroller{max-height:100vh!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/mobileWrappers/NotificationsWrapper/NotificationsWrapper.scss
// module id = 1869
// module chunks = 0